import React from 'react'
import { sizes, socialIconColors } from './const'
export interface FacebookProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analitics.
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * The color of the icon including the cirlce.
     * */
    color?: 'white' | 'black'
}

export const FacebookIcon = ({
    className = 'js_FacebookIcon',
    size = 'large',
    color = 'black',
}: FacebookProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
            fill="none"
            viewBox="0 0 32 32"
        >
            <g fillRule="evenodd">
                <circle
                    className={`${socialIconColors[color][0]}`}
                    cx={16}
                    cy={16}
                    r={15.5}
                />
                <path
                    className={`${socialIconColors[color][1]}`}
                    stroke="none"
                    d="M19.243 14.09H17.05v-1.44c0-.54.358-.666.61-.666h1.55V9.608L17.074 9.6c-2.367 0-2.906 1.772-2.906 2.906v1.584H12.8v2.448h1.37v6.929h2.879v-6.928h1.943l.251-2.449z"
                />
            </g>
        </svg>
    )
}
